import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanesProvider, PlanHtml, ProyectQr } from '../../../providers/planes';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-carpeta',
    templateUrl: './carpeta.component.html',
    styleUrls: ['./carpeta.component.css']
})
export class CarpetaComponent implements OnInit {

    plan: PlanHtml;
    proyectQr: ProyectQr;
    urlQr: string = '';

    constructor(private navParams: ActivatedRoute, private _planes: PlanesProvider) {
        this._planes.findByUser(this.navParams.snapshot.paramMap.get('idu')).then(planUser => {
            this.plan = planUser;
            this.proyectQr = planUser.proyectsQr[this.navParams.snapshot.paramMap.get('carpeta')];
            this.urlQr = environment.dominioUrl + '/dashboard/' + this.navParams.snapshot.paramMap.get('idu') + '/' + this.navParams.snapshot.paramMap.get('idp') + '/' + this.navParams.snapshot.paramMap.get('carpeta');
            console.log(planUser, this.proyectQr, this.urlQr);
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/dash/carpeta/carpeta.component.ts